import { IconGroup as InnerIconGroup, IconGroupItem } from './icon-group';
const IconGroup = InnerIconGroup;
IconGroup.Item = IconGroupItem;
export default IconGroup;
